import type { ReactNode, SVGProps } from "react";

/**
 * Glyphs for the helpdesk, NOC rooming and Hotel views, her paths (`l3.js`
 * `UI.P`): inbox, bed, download, door (check in / out), list, user. 24-unit
 * boxes, 1.8 stroke, `currentColor`; the caller sizes them in rem.
 */
type P = Omit<SVGProps<SVGSVGElement>, "viewBox" | "children">;

function Glyph({ children, ...props }: P & { children: ReactNode }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable={false} {...props}>
			{children}
		</svg>
	);
}

export const InboxIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M3.5 13.5 6 5h12l2.5 8.5V19H3.5z" />
		<path d="M3.5 13.5H8l1.5 2.5h5l1.5-2.5h4.5" />
	</Glyph>
);

export const BedIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M3 18V6M3 14h18v4M21 14v-2.5A2.5 2.5 0 0 0 18.5 9H11v5" />
		<circle cx="7" cy="11" r="1.6" />
	</Glyph>
);

export const DownloadIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M12 4v11M7.5 10.5 12 15l4.5-4.5M5 19.5h14" />
	</Glyph>
);

/** Check in / out: a door. */
export const DoorIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M6 20.5V4.5A1 1 0 0 1 7 3.5h10a1 1 0 0 1 1 1v16M4 20.5h16" />
		<circle cx="14.5" cy="12.5" r=".9" fill="currentColor" stroke="none" />
	</Glyph>
);

export const ListLinesIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M9 6.5h11M9 12h11M9 17.5h11M4.5 6.5h.01M4.5 12h.01M4.5 17.5h.01" />
	</Glyph>
);

export const UserIcon = (p: P) => (
	<Glyph {...p}>
		<circle cx="12" cy="8.5" r="3.5" />
		<path d="M5 20a7 7 0 0 1 14 0" />
	</Glyph>
);

export const RefreshIcon = (p: P) => (
	<Glyph {...p}>
		<path d="M20 11.5A8 8 0 0 0 6 6.3L4 8.5M4 4v4.5h4.5M4 12.5a8 8 0 0 0 14 5.2l2-2.2M20 20v-4.5h-4.5" />
	</Glyph>
);
